import React from "react";
import { Link } from "react-router";
import styles from "./style.module.css";

export interface Device {
  label: string;
  value: string;
}

interface Props {
  list: Device[];
}

function List(props: Props) {
  const { list } = props;

  return (
    <div className={styles.list}>
      {list.map(item => (
        <div className={styles.item} key={item.label}>
          <Link to={item.value}>
            <h3>{item.label}</h3>
          </Link>
        </div>
      ))}
    </div>
  );
}

export default List;